<div class="au-mat-chip-list">
	<mat-chip-listbox>
		@for (chip of chips; track chip) {
			<mat-chip-option class="cmms-chip" (removed)="deleteChipHandler(chip)">
				<span class="text-wrapper">
					<span>{{ getName(chip) }}</span>
				</span>
				<button class="mat-chip-button" matChipRemove>
					<mat-icon>cancel</mat-icon>
				</button>
			</mat-chip-option>
		}
	</mat-chip-listbox>
</div>
